import SqFetch from 'typescript/application/sq_fetch';
import { _handleResponse } from 'typescript/clients/utilities/handle_http_response';
import { GetSavedCardsResponse } from 'typescript/types/api/payment_sources';
// functions are controlled by the methods in this controller
// app/controllers/sq/api/payment_sources_controller.rb

export const PAYMENT_SOURCES_BASE_URL = '/shop/api/v1/saved-payment-sources';

/**
 * Get Saved Cards
 * @returns saved cards for the current user
 */
export const getSavedCards = async (): Promise<GetSavedCardsResponse> => {
  const response = await SqFetch.get(`${PAYMENT_SOURCES_BASE_URL}`);

  return _handleResponse(response);
};

/**
 * Delete a saved card
 * @returns success or error message
 */
export const deleteSavedCard = async ({
  cardId,
}: {
  cardId: number;
}): Promise<{ success: boolean }> => {
  const response = await SqFetch.delete(
    `${PAYMENT_SOURCES_BASE_URL}/${cardId}`,
  );

  return _handleResponse(response);
};
